$(document).ready(function() {

  ww = $('body').width();
  $('.node-type-article .align-center').width(ww);
});